import { useState } from "react"

const defaultImage = require('../../../imagesLayout/perfil-sin-foto.jpg')

const PreviewImage = ({file, ...props}) => {
    return(
        <div className="object-contain bg-gray-700 rounded-t-lg">
            <img src={file ? file : defaultImage} alt="preview" {...props}/>
        </div>
    )
}

export default PreviewImage